import { useState } from "react";
import { ArrowRight, Smartphone, Share2, Plus } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

// Lower-right dashboard promo — "Take Fieldlink to the field".
// Button opens install-on-phone instructions (the app is a PWA).
export function MobileAppPromo() {
  const [open, setOpen] = useState(false);
  const origin = window.location.origin;
  return (
    <>
      <div className="relative ops-card ops-card-hover overflow-hidden min-h-[200px] flex" data-testid="mobile-app-promo">
        <img src="/brand/mobile-promo.jpg" alt="" className="absolute inset-0 w-full h-full object-cover object-right" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0B101A]/95 via-[#0B101A]/70 to-transparent" />
        <div className="relative p-5 flex flex-col justify-center max-w-[220px]">
          <div className="text-[19px] font-extrabold leading-tight text-white">
            Take Fieldlink<br />to the field
          </div>
          <div className="text-[12px] text-zinc-300 mt-1.5 leading-snug">The full power in your crew&rsquo;s pocket.</div>
          <button
            type="button"
            onClick={() => setOpen(true)}
            className="mt-4 inline-flex items-center gap-1.5 self-start rounded-lg bg-[#FF5F15] hover:bg-[#E64A00] text-white text-[12px] font-bold px-3.5 py-2 transition-colors"
            data-testid="mobile-promo-btn"
          >
            View Mobile App <ArrowRight className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-md" data-testid="mobile-promo-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Smartphone className="w-5 h-5 text-[#FF5F15]" /> Fieldlink on your phone
            </DialogTitle>
            <DialogDescription>
              Fieldlink is on Google Play for Android, or add it to your home screen on iPhone.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 text-sm">
            <div className="rounded-lg border border-zinc-200 dark:border-white/10 p-3">
              <div className="font-bold mb-1">On your phone, open</div>
              <div className="text-zinc-500 dark:text-zinc-400 break-all font-mono text-xs">{origin}</div>
            </div>
            <div className="rounded-lg border border-zinc-200 dark:border-white/10 p-3">
              <div className="font-bold mb-1.5">Android — get it on Google Play</div>
              <a href="https://play.google.com/store/apps/details?id=nz.co.fieldlink.app" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-md bg-[#142635] text-white font-bold text-xs px-3 py-2" data-testid="mobile-promo-play">
                <Smartphone className="w-4 h-4 text-[#3DDC84] shrink-0" /> Open on Google Play
              </a>
              <div className="font-bold mt-3 mb-1.5">iPhone — add to Home Screen</div>
              <div className="flex items-center gap-2 text-zinc-600 dark:text-zinc-300">
                <Share2 className="w-4 h-4 text-[#FF5F15] shrink-0" />
                <span>In Safari: Share, then <b>Add to Home Screen</b></span>
              </div>
            </div>
            <div className="flex items-center gap-2 text-zinc-500 dark:text-zinc-400 text-xs">
              <Plus className="w-3.5 h-3.5" /> Crew sign in with the same login — timesheets, pre-starts and hazards work offline.
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
